import NavBar from './NavBar';

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/index.js